import React from 'react';

import Button from 'sharedreact/components/Button';

type Props = {
  id: string,
  className?: string,
  disabled?: boolean,
  type?: string,
  icon?: string,
  badgeValue?: React.ReactNode,
  children?: React.ReactNode,
  collapsable?: boolean,
  onlyShowIconWhenCollapsed?: boolean,
  active?: boolean,
  autoFocus?: boolean,
  title?: string,

  onClick?: React.MouseEventHandler<HTMLButtonElement>,
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>,
  onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>
};

class ToolButton extends React.Component<Props> {
  override render (): React.ReactNode {
    return <Button collapsable {...this.props} />;
  }
}

export default ToolButton;
